module.exports = __webpack_public_path__ + "media/images/application/icons/icon-megaphon-e891ded0849adf7557dd5f01abe62755.svg";